/**
 * WordPress Data Store for TopBuddy Settings
 * 
 * Manages settings state for notification bars
 * 
 * @package TopBuddy
 */

import { createReduxStore, register } from '@wordpress/data';

const STORE_NAME = 'topbuddy/settings';

const DEFAULT_STATE = {
	settings: {},
};

const actions = {
	setSettings(settings) {
		return {
			type: 'SET_SETTINGS',
			settings,
		};
	},
	updateSetting(key, value) {
		return {
			type: 'UPDATE_SETTING',
			key,
			value,
		};
	},
};

const reducer = (state = DEFAULT_STATE, action) => {
	switch (action.type) {
		case 'SET_SETTINGS':
			return {
				...state,
				settings: action.settings,
			};
		case 'UPDATE_SETTING':
			return {
				...state,
				settings: {
					...state.settings,
					[action.key]: action.value,
				},
			};
		default:
			return state;
	}
};

const selectors = {
	getSettings(state) {
		return state.settings;
	},
	getSetting: (state) => (key) => {
		return state.settings[key] || null;
	},
};

const store = createReduxStore(STORE_NAME, {
	reducer,
	actions,
	selectors,
});

// Only register if not already registered
if (!window.wp.data.select(STORE_NAME)) {
	register(store);
}

export default store;
